import { useCallback, useEffect, useState } from 'react';
import useApiCall from '../../../../hooks/useApiCall';
import TriangulationService from '../../../../services/TriangulationService';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { CsvParsedType, ListType, TriangulationDataFromApi } from '../../types';
import { toast } from 'react-toastify';

export default function useLoadTriangulation() {
  const [isLoadLoading, setIsLoadLoading] = useState(false);
  const [rolesList, setRolesList] = useState<ListType>([{ value: 'Todos', label: 'Todos' }]);
  const [sindList, setSindsList] = useState<ListType>([{ value: 'Todos', label: 'Todos' }]);
  const [employeesList, setEmployeesList] = useState<ListType>([]);
  const [currentWorkplaceList, setCurrentWorkplaceList] = useState<ListType>([]);
  const [destinyWorkplaceList, setDestinyWorkplaceList] = useState<ListType>([]);
  const [dataList, setDataList] = useState<CsvParsedType[]>([]);
  const [apiFetched, setApiFetched] = useState(true);

  const { apiCall } = useApiCall();
  const { userCode, userProfile, companyCode } = useGetGeneralAppData();

  const getTriangulationData = useCallback(async () => {
    await apiCall({
      apiToCall: TriangulationService.listTriangulationData,
      queryParams: { codUsu: userCode, perfilUsu: userProfile, codEmpresa: companyCode },
      onStartLoad: () => setIsLoadLoading(true),
      onEndLoad: () => setIsLoadLoading(false),
      actionAfterResponse: (response: TriangulationDataFromApi) => {
        if (!response.codigo) {
          toast.error(`Não foi possível carregar os dados de triangulação (${response.msg})`);
          setDataList([]);
          setEmployeesList([]);
          setCurrentWorkplaceList([]);
          setDestinyWorkplaceList([]);
          setRolesList([{ value: 'Todos', label: 'Todos' }]);
          setSindsList([{ value: 'Todos', label: 'Todos' }]);
          return;
        }
        setDataList(response.dadosArq);
        setEmployeesList(response.listaFuncs.map((func) => ({
          value: func.cpf, label: `${func.nome} ${func.matricula && `- ${func.matricula}`}`,
        })));
        setCurrentWorkplaceList(response.listaLTAtual.map((ltA) => ({
          value: ltA.LTACod, label: ltA.LTADescr,
        })));
        setDestinyWorkplaceList(response.listaLTIndicado.map((ltI) => ({
          value: ltI.LTICod, label: ltI.LTIDescr,
        })));
        setSindsList(response.listaSindicato.map((sind) => ({
          value: sind.codSindicato, label: String(sind.codSindicato),
        })));
        setRolesList(response.listaCargos.map((role) => ({
          value: role.descrCargo, label: role.descrCargo,
        })));
        setApiFetched(true);
      },
      catchAction: () => setApiFetched(false),
      catchMessage: 'Não foi possível carregar os dados de triangulação',
    });
  }, [apiCall, companyCode, userCode, userProfile]);

  useEffect(() => {
    if (companyCode) {
      getTriangulationData();
    }
  }, [companyCode, getTriangulationData]);

  return {
    isLoadLoading,
    setIsLoadLoading,
    rolesList,
    setRolesList,
    sindList,
    setSindsList,
    employeesList,
    setEmployeesList,
    currentWorkplaceList,
    setCurrentWorkplaceList,
    destinyWorkplaceList,
    setDestinyWorkplaceList,
    dataList,
    setDataList,
    apiFetched,
    getTriangulationData,
  };
}
